import type * as React from 'react';

function SvgGolf(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="16" viewBox="0 0 11 16" width="11" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M0 5.5C0 7.47509 1.04685 9.21086 2.61508 10.181C2.54322 10.2676 2.5 10.3788 2.5 10.5V12.5C2.5 12.776 2.724 13 3 13H4V15.5C4 15.776 4.224 16 4.5 16H6.5C6.776 16 7 15.776 7 15.5V13H8C8.276 13 8.5 12.776 8.5 12.5V10.5C8.5 10.3787 8.45672 10.2674 8.38477 10.1808C9.95285 9.21064 11 7.47497 11 5.5C11 2.467 8.532 0 5.5 0C2.467 0 0 2.467 0 5.5ZM5 15V13H6V15H5ZM3.5 12H4.5H6.5H7.5V11H5.5H3.5V12ZM10 5.5C10 7.981 7.981 10 5.5 10C3.019 10 1 7.981 1 5.5C1 3.019 3.019 1 5.5 1C7.981 1 10 3.019 10 5.5ZM5.02 3C4.744 3 4.515 2.776 4.515 2.5C4.515 2.224 4.734 2 5.01 2H5.02C5.296 2 5.52 2.224 5.52 2.5C5.52 2.776 5.296 3 5.02 3ZM3.015 3C3.015 3.276 3.244 3.5 3.52 3.5C3.796 3.5 4.02 3.276 4.02 3C4.02 2.724 3.796 2.5 3.52 2.5H3.51C3.234 2.5 3.015 2.724 3.015 3ZM2.515 4.5C2.515 4.776 2.744 5 3.02 5C3.296 5 3.52 4.776 3.52 4.5C3.52 4.224 3.296 4 3.02 4H3.01C2.734 4 2.515 4.224 2.515 4.5ZM4.015 4C4.015 4.276 4.244 4.5 4.52 4.5C4.796 4.5 5.02 4.276 5.02 4C5.02 3.724 4.796 3.5 4.52 3.5H4.51C4.234 3.5 4.015 3.724 4.015 4Z"
        fill="#327EA5"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgGolf;
